import { call, put, select, takeLatest } from 'redux-saga/effects';
import { makeSelectUsername } from 'store/app/selectors';
import { makeSelectTokenBearerToken } from 'store/oauth/selectors';
import { ResponseFetcher } from 'utils/fetcher/types';
import {
  getCursos,
  getCursosCount,
  getReportCoursesClosing,
  getReportCoursesClosingCount,
  setAllSociedades,
  setAlumnosCurso,
  setAlumnosCursos,
  setAlumnosCursosCount,
  setCursos,
  setCursosCount,
  setCursosFilter,
  setEstadosCursos,
  setProvinciasCursos,
  setProvinciasCursosCierres,
  setReportCoursesClosing,
  setReportCoursesClosingCount,
  setSociedadesCursos,
  setSociedadesCursosCierres,
  setAllGestores,
  setGetAllGestoresRequestStatus,
  setInsertarGestoresCursoRequestStatus,
  setEliminarGestoresCursoRequestStatus,
  setAllFormadores,
  setGetAllFormadoresRequestStatus,
  setInsertarFormadoresCursoRequestStatus,
  setEliminarFormadoresCursoRequestStatus,
  setAllAlumnos,
  setGetAllAlumnosRequestStatus,
  setInsertarAlumnosCursoRequestStatus,
  setEliminarAlumnosCursoRequestStatus,
} from './actions';
import { ActionTypes } from './actionTypes';
import { GetAllGestoresRequest, GestorTabla, GetAllFormadoresRequest, FormadorTabla, GetAllAlumnosRequest, AlumnoTabla } from './types';
import { RequestStatusTypes, RouteTypes, TxtTypes } from 'consts';
import {
  getAlumnosCursoCountRequest,
  getAlumnosCursoRequest,
  getCursosCountRequest,
  getCursosRequest,
  getFilterComboCursosRequest,
  getFilterProvinciasCursosRequest,
  getReportCoursesClosingCountRequest,
  getReportCoursesClosingProvinciasRequest,
  getReportCoursesClosingRequest,
  setCourseStatusRequest,
  getAllGestoresRequest,
  postGestoresCursosRequest,
  deleteGestoresCursosRequest,
  getAllFormadoresRequest,
  postFormadoresCursosRequest,
  deleteFormadoresCursosRequest,
  getAllAlumnosRequest,
  postAlumnosCursosRequest,
  deleteAlumnosCursosRequest,

} from './requests';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { ExportExcelData } from 'store/practicas/types';
import { exportDataTableExcel } from 'utils/export-excel';
import { calculateDaysClosure, parseDate } from 'utils/parsePractices';
import { userProfile } from 'utils/profilesIndex';
import {
  getEstadosCursosRequestSaga,
  getInfoUsersRequestSaga,
  getSociedadesRequestSaga,
} from 'store/app/sagas';
import { estados } from 'utils/estados';
import {
  makeSelectAllSociedades,
  makeSelectSociedadesCursosParsed,
} from './selectors';
import { getCursoSeleccionado } from 'store/app/requests';
import { setAlert, setLoading, setMsgSubmit, setModalDraftType} from 'store/app/actions';
import { getUserProfileName } from 'store/practicas/sagas';

export default function* sagas() {
  // Alumnos
  yield takeLatest(
    [ActionTypes.GET_ALUMNOS_CURSOS],
    getAlumnosCursosRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_ALUMNOS_CURSOS_COUNT],
    getAlumnosCursosCountRequestSaga
  );

  yield takeLatest(
    [ActionTypes.GET_EXCEL_ALUMNOS_CURSOS],
    getExcelAlumnosCursosRequestSaga
  );

  yield takeLatest([ActionTypes.GET_ALUMNOS_CURSO], getAlumnosCursoRequestSaga);

  // Cursos
  yield takeLatest([ActionTypes.GET_CURSOS], getCursosRequestSaga);
  yield takeLatest([ActionTypes.GET_CURSOS_COUNT], getCursosCountRequestSaga);
  yield takeLatest([ActionTypes.GET_EXCEL_CURSOS], getExcelCursosRequestSaga);

  yield takeLatest(
    [ActionTypes.GET_SOCIEDADES_CURSOS],
    getSociedadesCursosRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_PROVINCIAS_CURSOS],
    getProvinciasCursosRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_ESTADOS_CURSOS],
    getEstadosCursosFilterRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_CURSOS_FILTER],
    getFilterComboCursosRequestRequestSaga
  );

  yield takeLatest([ActionTypes.SET_ESTADO_CURSO], setEstadoCursoRequestSaga);

  // Cursos cierre
  yield takeLatest(
    [ActionTypes.GET_REPORT_COURSES_CLOSING],
    getReportCoursesClosingRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_REPORT_COURSES_CLOSING_COUNT],
    getReportCoursesClosingCountRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_EXCEL_COURSES_CLOSING],
    getExcelReportCoursesClosingRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_SOCIEDADES_CURSOS_CIERRES],
    getSociedadesCursosCierreRequestSaga
  );
  yield takeLatest(
    [ActionTypes.GET_PROVINCIAS_CURSOS_CIERRES],
    getReportCoursesClosingProvinciasRequestSaga
  );
  //panel administracion
  //gestores
  yield takeLatest(ActionTypes.GET_ALL_GESTORES, getAllGestoresRequestSaga);
  yield takeLatest(ActionTypes.INSERTAR_GESTORES_CURSOS, insertarGestoresCursosRequestSaga);
  yield takeLatest(ActionTypes.ELIMINAR_GESTORES_CURSOS, eliminarGestoresCursosRequestSaga);

  //formadores
  yield takeLatest(ActionTypes.GET_ALL_FORMADORES, getAllFormadoresRequestSaga);
  yield takeLatest(ActionTypes.INSERTAR_FORMADORES_CURSOS, insertarFormadoresCursosRequestSaga);
  yield takeLatest(ActionTypes.ELIMINAR_FORMADORES_CURSOS, eliminarFormadoresCursosRequestSaga);

  //alumnos
  yield takeLatest(ActionTypes.GET_ALL_ALUMNOS, getAllAlumnosRequestSaga);
  yield takeLatest(ActionTypes.INSERTAR_ALUMNOS_CURSOS, insertarAlumnosCursosRequestSaga);
  yield takeLatest(ActionTypes.ELIMINAR_ALUMNOS_CURSOS, eliminarAlumnosCursosRequestSaga);

}

// Alumnos

export function* alumnosCursosRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };

  const response: ResponseFetcher<any> = yield call(
    getAlumnosCursoRequest,
    payload
  );
  return response;
}

function* getAlumnosCursosGetinfoUsersParsed(params) {
  const alumnosResponse: ResponseFetcher<any> = yield call(
    alumnosCursosRequestSaga,
    params
  );
  const alumnos = alumnosResponse.data;

  const alumnosIds = alumnos.map((item) => item.ID_ALUMNO).join(',');
  const infoUsersResponse: ResponseFetcher<any> = yield call(
    getInfoUsersRequestSaga,
    alumnosIds
  );
  const infoUsers = infoUsersResponse.data;

  const alumnosParsed: any[] = [];

  alumnos.forEach((alumno) => {
    const user: any = infoUsers.find(
      (user: any) => user.ID_USUARIO === alumno.ID_ALUMNO
    );
    if (user) {
      user.nombre_perfil = getUserProfileName(user.ID_PERFIL);
    }
    alumnosParsed.push({
      ...alumno,
      perfil_parsed: user?.PERFIL || '',
      tipo_ie: user?.TIPO_IE || '',
      sociedad_parsed: user?.DESC_SOCIEDAD || '',
      nombre_perfil: user?.nombre_perfil || '',
    });
  });

  return alumnosParsed;
}

export function* getAlumnosCursosRequestSaga(params) {
  try {
    const alumnosParsed = yield call(
      getAlumnosCursosGetinfoUsersParsed,
      params.payload
    );
    yield put(setAlumnosCursos(alumnosParsed));

    /* else {
      throw new Error(`Error: ${ActionTypes.GET_ALUMNOS_CURSOS}`);
    } */
  } catch (err) {
    console.error(err);
  }
}

export function* getAlumnosCursosCountRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getAlumnosCursoCountRequest,
      payload
    );

    if (response.ok) {
      yield put(setAlumnosCursosCount(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_ALUMNOS_CURSOS_COUNT}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getExcelAlumnosCursosRequestSaga(params) {
  try {
    const alumnosParsed = yield call(getAlumnosCursosGetinfoUsersParsed, {
      ...params.payload.filter,
      elemInicio: -1,
      elemFin: -1,
    });

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: `listado_alumnos_${params.payload.filter.cursoId}_${new Date()
        .getTime()
        .toString()}`,
    };

    params.payload.excelConfig.literals.forEach((item) => {
      EXPORT_EXCEL.headerExcelFile.push(item.text);
      EXPORT_EXCEL.headerColumsConfig.push({
        label: item.text,
        key: item.text,
        width: 30,
      });
    });

    alumnosParsed.forEach((item) => {
      const itemArray = [
        item.ID_ALUMNO,
        item.NOMBRE_ALUMNO,
        parseDate(item.FECHA_INI_ALUM_CURSO),
        parseDate(item.FECHA_FIN_ALUM_CURSO),
        item.nombre_perfil,
        item.sociedad_parsed,
      ];

      EXPORT_EXCEL.bodyExcelFile.push(itemArray);
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

export function* getAlumnosCursoRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      cursoId: params.payload,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<any> = yield call(
      getCursoSeleccionado,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setAlumnosCurso(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_ALUMNOS_CURSO}`);
    }
  } catch (err) {
    console.error(err);
  }
}

// Cursos

export function* cursosRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );
  const sociedades = JSON.parse(
    yield select(makeSelectSociedadesCursosParsed())
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };

  const response: ResponseFetcher<any> = yield call(getCursosRequest, payload);

  const parsedCourses =
    Object.keys(response.data).length !== 0
      ? response.data.map((course) => {
          const sociedadFound = sociedades.find(
            (sociedad) => sociedad.value === course.SOCIEDAD_CURSO
          );

          return {
            ...course,
            sociedad_parsed: sociedadFound?.item.NOMBRE_SOCIEDAD || '',
          };
        })
      : response.data;

  return {
    ...response,
    data: parsedCourses,
  };
}

export function* getCursosRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      cursosRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setCursos(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_CURSOS}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getExcelCursosRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(cursosRequestSaga, {
      ...params.payload.filter,
      elemInicio: -1,
      elemFin: -1,
      elemFinal: -1,
    });

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: 'listado_cursos_' + new Date().getTime().toString(),
    };

    params.payload.excelConfig.literals.forEach((item) => {
      EXPORT_EXCEL.headerExcelFile.push(item.text);
      EXPORT_EXCEL.headerColumsConfig.push({
        label: item.text,
        key: item.text,
        width: 30,
      });
    });

    const profileActive = params.payload.excelConfig.profile;

    response.data.forEach((item) => {
      const commonFields = [
        item.ID_CURSO,
        item.NOMBRE_CURSO,
        parseDate(item.FECHA_INI_CURSO),
        parseDate(item.FECHA_FIN_CURSO),
        item.sociedad_parsed,
      ];

      const additionalFields =
        profileActive.ID_PERFIL === userProfile.formador ||
        profileActive.ID_PERFIL === userProfile.gestor ||
        profileActive.ID_PERFIL === userProfile.administrador ||
        profileActive.ID_PERFIL === userProfile.supervisor ||
        profileActive.ID_PERFIL === userProfile.visualizador
          ? [
              item.PROVINCIA_CURSO,
              item.FECHA_MODIFICACION_DATE
                ? parseDate(item.FECHA_MODIFICACION)
                : '',
              item.USUARIO_MOD,
              item.FECHA_CAMBIO_EST ? parseDate(item.FECHA_CAMBIO_EST) : '',
            ]
          : [];

      const estadoFields = [estados[item.ID_ESTADO]];

      EXPORT_EXCEL.bodyExcelFile.push([
        ...commonFields,
        ...additionalFields,
        ...estadoFields,
      ]);
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

export function* getCursosCountRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getCursosCountRequest,
      payload
    );

    if (response.ok) {
      yield put(setCursosCount(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_CURSOS_COUNT}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getSociedadesCursosRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      getSociedadesRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setSociedadesCursos(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_SOCIEDADES_CURSOS}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getProvinciasCursosRequest(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    sociedades: '',
    ...params,
  };

  const response: ResponseFetcher<any> = yield call(
    getFilterProvinciasCursosRequest,
    payload
  );

  return response;
}

export function* getProvinciasCursosRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      getProvinciasCursosRequest,
      params.payload
    );

    if (response.ok) {
      yield put(setProvinciasCursos(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_PROVINCIAS_CURSOS}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getEstadosCursosFilterRequestSaga(params) {
  try {
    const saved = JSON.parse(
      sessionStorage.getItem('savedEstadosCursos') || '{"isSaved": false}'
    );

    if (saved.isSaved === undefined) {
      yield put(setEstadosCursos(saved));
    } else {
      const response: ResponseFetcher<any> = yield call(
        getEstadosCursosRequestSaga /* , params.payload */
      );

      if (response.ok) {
        sessionStorage.setItem(
          'savedEstadosCursos',
          JSON.stringify(response.data)
        );
        yield put(setEstadosCursos(response.data));
      } else {
        throw new Error(`Error: ${ActionTypes.GET_PROVINCIAS_CURSOS}`);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterComboCursosRequestRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: '',
      estados: 'IN',
      provincias: '',
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getFilterComboCursosRequest,
      payload
    );

    if (response.ok) {
      yield put(setCursosFilter(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_PROVINCIAS_CURSOS}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* setEstadoCursoRequestSaga(
  params /* : { payload: { params: any, filter: any } } */
) {
  try {
    setLoading(true);
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload.params,
    };

    const response: ResponseFetcher<any> = yield call(
      setCourseStatusRequest,
      payload
    );

    if (response.ok) {
      yield put(
        setAlert({
          modalType: 'success',
          message: 'Curso cambiado a estado: ' + estados[payload.estadoId],
        })
      );

      if (params.payload.cursosCierre) {
        yield put(getReportCoursesClosing(params.payload.filter));
        yield put(getReportCoursesClosingCount(params.payload.filter));
      } else {
        yield put(getCursos(params.payload.filter));
        yield put(getCursosCount(params.payload.filter));
      }
      setLoading(false);
    } else {
      setLoading(false);
      throw new Error(`Error: ${ActionTypes.SET_ESTADO_CURSO}`);
    }
  } catch (err) {
    setLoading(false);
    console.error(err);
  }
}

// Cursos cierre

export function* reportCoursesClosingRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };

  const response: ResponseFetcher<any> = yield call(
    getReportCoursesClosingRequest,
    payload
  );

  return response;
}

export function* getReportCoursesClosingCountRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getReportCoursesClosingCountRequest,
      payload
    );

    if (response.ok) {
      yield put(setReportCoursesClosingCount(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_REPORT_COURSES_CLOSING_COUNT}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getReportCoursesClosingRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      reportCoursesClosingRequestSaga,
      params.payload
    );

    if (response.ok) {
      yield put(setReportCoursesClosing(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_REPORT_COURSES_CLOSING}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getExcelReportCoursesClosingRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      reportCoursesClosingRequestSaga,
      { ...params.payload.filter, elemInicio: -1, elemFin: -1, elemFinal: -1 }
    );
    const allSociedades = yield select(makeSelectAllSociedades());

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: 'listado_cursos_cierre_' + new Date().getTime().toString(),
    };

    params.payload.excelConfig.literals.forEach((item) => {
      EXPORT_EXCEL.headerExcelFile.push(item.text);
      EXPORT_EXCEL.headerColumsConfig.push({
        label: item.text,
        key: item.text,
        width: 30,
      });
    });

    response.data.forEach((item) => {
      const itemArray = [
        item.ID_CURSO,
        item.NOMBRE_CURSO,
        parseDate(item.FECHA_INI_CURSO),
        parseDate(item.FECHA_FIN_CURSO),
        allSociedades.find(
          (sociedad) => sociedad.ID_SOCIEDAD === item.SOCIEDAD_CURSO
        ).NOMBRE_SOCIEDAD,
        item.PROVINCIA_CURSO,
        parseDate(item.FECHA_MODIFICACION),
        item.USUARIO_MOD || '-',
        parseDate(item.FECHA_CAMBIO_EST),
        estados[item.ID_ESTADO],
        calculateDaysClosure(item.FECHA_FIN_CURSO),
      ];

      EXPORT_EXCEL.bodyExcelFile.push(itemArray);
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

export function* getReportCoursesClosingProvinciasRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      sociedades: '',
      ...params.payload,
    };

    const response: ResponseFetcher<any> = yield call(
      getReportCoursesClosingProvinciasRequest,
      payload
    );

    if (response.ok) {
      yield put(setProvinciasCursosCierres(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_CURSOS_COUNT}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getSociedadesCursosCierreRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      getSociedadesRequestSaga,
      params.payload
    );
    const sociedadesCache = yield select(makeSelectAllSociedades());

    if (response.ok) {
      yield put(setSociedadesCursosCierres(response.data));

      if (!sociedadesCache.length) {
        yield put(setAllSociedades(response.data));
      }
    } else {
      throw new Error(`Error: ${ActionTypes.GET_SOCIEDADES_CURSOS_CIERRES}`);
    }
  } catch (err) {
    console.error(err);
  }
}

//panel administracion
//gestores
export function* getAllGestoresRequestSaga() {
  try {

      const response: ResponseFetcher<GestorTabla[]> = yield call(
        getAllGestoresRequest,
      );

        if (response.ok) {
          yield put(setAllGestores(response.data));
          yield put(
              setGetAllGestoresRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        }else {
          yield put(
            setGetAllGestoresRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.GET_ALL_GESTORES}`);

      }


    } catch (err) {
      console.error(err);
    }
}




export function* insertarGestoresCursosRequestSaga(params) {
  try {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const usuario = yield select(makeSelectUsername());
      params.payload.usuarioModificacion = usuario;
      params.payload.usuarioAlta = usuario;



      const response: ResponseFetcher<any> = yield call(
        postGestoresCursosRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setInsertarGestoresCursoRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
          yield call(getAllGestoresRequestSaga);
        }else {
          yield put(
            setInsertarGestoresCursoRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.INSERTAR_GESTORES_CURSOS}`);

      }


    } catch (err) {
      console.error(err);
    }
}

export function* eliminarGestoresCursosRequestSaga(params) {
    try {
      const bearerToken = yield select(makeSelectTokenBearerToken());

      const response: ResponseFetcher<any> = yield call(
        deleteGestoresCursosRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setEliminarGestoresCursoRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        yield call(getAllGestoresRequestSaga);
        }else {
          yield put(
            setEliminarGestoresCursoRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.ELIMINAR_GESTORES_CURSOS}`);

      }


    } catch (err) {
      console.error(err);
    }
}

//formadores
export function* getAllFormadoresRequestSaga() {
    try {

      const response: ResponseFetcher<FormadorTabla[]> = yield call(
        getAllFormadoresRequest,
      );

        if (response.ok) {
          yield put(setAllFormadores(response.data));
          yield put(
              setGetAllFormadoresRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        }else {
          yield put(
            setGetAllFormadoresRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.GET_ALL_FORMADORES}`);

      }

    } catch (err) {
      console.error(err);
    }
}

export function* insertarFormadoresCursosRequestSaga(params) {
    try {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const usuario = yield select(makeSelectUsername());
      params.payload.usuarioModificacion = usuario;
      params.payload.usuarioAlta = usuario;


      const response: ResponseFetcher<any> = yield call(
        postFormadoresCursosRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setInsertarFormadoresCursoRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        yield call(getAllFormadoresRequestSaga);
        }else {
          yield put(
            setInsertarFormadoresCursoRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.INSERTAR_FORMADORES_CURSOS}`);

      }


    } catch (err) {
      console.error(err);
    }
}

export function* eliminarFormadoresCursosRequestSaga(params) {
    try {
      const bearerToken = yield select(makeSelectTokenBearerToken());

      const response: ResponseFetcher<any> = yield call(
        deleteFormadoresCursosRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setEliminarFormadoresCursoRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        yield call(getAllFormadoresRequestSaga);
        }else {
          yield put(
            setEliminarFormadoresCursoRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.ELIMINAR_GESTORES_CURSOS}`);

      }


    } catch (err) {
      console.error(err);
    }
}

//alumnos

export function* getAllAlumnosRequestSaga() {
    try {

      const response: ResponseFetcher<AlumnoTabla[]> = yield call(
        getAllAlumnosRequest
      );

        if (response.ok) {
          yield put(setAllAlumnos(response.data));
          yield put(
              setGetAllAlumnosRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        }else {
          yield put(
            setGetAllAlumnosRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.GET_ALL_ALUMNOS}`);

      }


    } catch (err) {
      console.error(err);
    }
}

export function* insertarAlumnosCursosRequestSaga(params) {
    try {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const usuario = yield select(makeSelectUsername());
      params.payload.usuarioModificacion = usuario;
      params.payload.usuarioAlta = usuario;


      const response: ResponseFetcher<any> = yield call(
        postAlumnosCursosRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setInsertarAlumnosCursoRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        yield call(getAllAlumnosRequestSaga);
        }else {
          yield put(
            setInsertarAlumnosCursoRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.INSERTAR_ALUMNOS_CURSOS}`);

      }


    } catch (err) {
      console.error(err);
    }
}

export function* eliminarAlumnosCursosRequestSaga(params) {
    try {
      const bearerToken = yield select(makeSelectTokenBearerToken());


      const response: ResponseFetcher<any> = yield call(
        deleteAlumnosCursosRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setEliminarAlumnosCursoRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
        yield call(getAllAlumnosRequestSaga);
        }else {
          yield put(
            setEliminarAlumnosCursoRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.ELIMINAR_ALUMNOS_CURSOS}`);

      }


    } catch (err) {
      console.error(err);
    }
}
